import {Middleware} from '@floating-ui/core';

const bound = (min: number, max: number, x: number) =>
  x < min ? min : x > max ? max : x;

const transformOrigin = ({
  apply,
}: {
  apply?: (args: any) => void;
}): Middleware => ({
  name: 'transformOrigin',
  async fn({rects: {floating, reference}, x, y}) {
    const absX =
      (floating.width * reference.x - reference.width * x) /
      (floating.width - reference.width);

    const absY =
      (floating.height * reference.y - reference.height * y) /
      (floating.height - reference.height);

    const origin = {
      x: bound(0, floating.width, absX - x),
      y: bound(0, floating.height, absY - y),
    };

    apply?.(origin);

    return {};
  },
});

export default transformOrigin;
